import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { GrainSize } from 'Components/Worksheets/MoistureContentWorksheet/types';
import qestIds from 'Components/Worksheets/QestIds';
import getLabelConfig from 'Components/Worksheets/WashWorksheet/BsEnIso/Config/labelConfig';
import getDerivedFromMeasurementsConfig from './derivedFromMeasurementsConfig';
import getMeasuredUsingConfig from './measuredUsingConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Preparation.GrainSize`]: {
        options: [
          { label: 'Fine', value: GrainSize.Fine },
          { label: 'Coarse', value: GrainSize.Coarse },
        ],
      },
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.DryingTray.DryMassReadings.DryingTime`]: {
        uom: 'h',
        format: { nearest: 0.1 },
      },
      /**
       * TODO: The readability of InitialDryMass can be derived from many different measurements
       * For now, we only use the default readability
       */
      [`${prefix}.Masses.InitialDryMass`]: {
        format: { nearest: 0.01 },
        uom: 'g',
      },
      [`${prefix}.Masses.InitialTareMass`]: {
        format: { nearest: 0.01 },
        uom: 'g',
      },
      [`${prefix}.Results.PercentPassingWashingSieve`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.PercentRetainedWashingSieve`]: { format: { nearest: 0.1 } },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Equipment.InitialBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.Equipment.WashedBalance`]: { defaultReadability: 0.01, defaultUom: 'g' },

      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.Balance`]: {
        defaultReadability: 0.01,
        defaultUom: 'g',
      },
      [`${prefix}.Masses.MeasuredWashedConstantDryMass.Equipment.DryMassBalance`]: {
        defaultReadability: 0.01,
        defaultUom: 'g',
      },
    },
    getLabelConfig(prefix)
  );

export { getConfig };

export default {
  [qestIds.wash.BS_EN_ISO_17892_4_Clause_5_2.Rev2016]: getConfig,
  [qestIds.wash.BS_EN_ISO_17892_4_Clause_5_3.Rev2016]: getConfig,
};
